export const HOUR_MILLISECONDS = 3_600_000
export const DAY_MILLISECONDS = 86_400_000
export const WEEK_MILLISECONDS = 604_800_000
export const MONTH_MILLISECONDS = 2_629_800_000
export const YEAR_MILLISECONDS = 31_556_952_000
